import * as React from "react";
import { Box, CircularProgress, useMediaQuery, useTheme } from "@mui/material";

export const LoadingElement = () => {
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down("sm")); // Checks if the screen size is 'sm' or smaller (e.g., mobile)

  return <CircularProgress size={isPhone ? 50 : 80} />;
};

export const LoadingElementInBox = ({
  viewHeight = "80vh",
}: { viewHeight?: string } = {}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: viewHeight,
      }}
    >
      <LoadingElement />
    </Box>
  );
};
